import React, { Component } from 'react'
import { post } from '../../utils/networking'
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";
import Footer from '../footer'
import Header from '../header'
import Overview from './overview'
import Reward from './reward'
import Setting from './setting'
import Referral from './referral'
import AppointmentList from '../appointmentList'
import $ from 'jquery'

export default class User extends Component {


    render() {
        return (
            <div id="user_page">
                <div className="user_header">
                    <p className="user_header_1">My Account</p>
                    <p className="user_header_2">Set Preferences, Track Rewards, Write Reviews and more!</p>
                </div>
                <div className="user_detail">
                    <div className="column left_column">
                        <ul className="left_menu">
                            <li>
                                <NavLink to="/user/overview">
                                    <i className="fas fa-eye" aria-hidden="true"></i>
                                    <p>Overview</p>
                                </NavLink>
                            </li>

                            <li>
                                <NavLink to="/user/appointment" >
                                    <i className="far fa-calendar-alt" aria-hidden="true"></i>
                                    <p>My appointment</p>
                                </NavLink>
                            </li>

                            <li>
                                <NavLink to="/user/reward">
                                    <i className="fa fa-trophy" aria-hidden="true"></i>
                                    <p>Rewards</p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/user/setting">
                                    <i className="fa fa-user-o" aria-hidden="true"></i>
                                    <p>Profile Settings</p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/user/referral">
                                    <i className="fa fa-sitemap" aria-hidden="true"></i>
                                    <p>Referral</p>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="column midle_column">
                        <Route exact path="/user" component={Overview} />
                        <Route exact path="/user/overview" component={Overview} />
                        <Route exact path="/user/reward" component={Reward} />
                        <Route exact path="/user/setting" component={Setting} />
                        <Route exact path="/user/referral" component={Referral} />
                        <Route exact path="/user/appointment" component={AppointmentList} />
                    </div>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/user/index.js